<template>
    <div ref="emblaRef" class="embla overflow-hidden h-full flex bg-lolo-600">
        <div class="embla__container flex flex-1">
            <div v-for="(img, i) in imgsprops" :key="img.src" class="embla__slide overflow-hidden min-w-0 flex-none w-full">
                <AirImg
                    v-bind="imgsprops[i]"
                    :loading="i === 0 ? 'eager' : 'lazy'"
                    :fetchpriority="i === 0 ? 'high' : 'low'"
                    class="flex-1 bg-lolo-400/10 size-full block will-change-transform"
                    :class="slideSelect === i ? 'animate-slide-zoom' : 'transition-all duration-800 scale-[1.16] opacity-0'"
                    image-class="lg:max-lg:object-bottom  object-cover"
                    alt="'Aire & Montagne' image d'accueil"
                />
            </div>
        </div>
        <div class="absolute inset-x-0 bottom-4 my-container flex justify-center md:justify-end">
            <div class="relative w-20 md:w-34 h-8 rounded-full overflow-hidden">
                <div class="group absolute inset-0 flex items-center justify-center" :class="{ anim: anim }">
                    <div class="h-3 w-0 bg-primary group-[.anim]:animate-slide-timer" :style="styleTimer" />
                    <!-- <div class="h-full bg-primary/50 group-[.anim]:animate-slide-timer" style="animation-duration': 5000ms" /> -->
                </div>
                <div class="absolute inset-0 flex gap-3 items-center justify-center bg-white/20 backdrop-blur-sm">
                    <div
                        v-if="$viewport.isGreaterThan('sm')"
                        class="size-9 text-white hover:text-primary transition-colors flex items-center justify-center rounded-full cursor-pointer"
                        @click="prevSlide"
                    >
                        <UIcon name="si:chevron-left-alt-line" :size="20" />
                    </div>
                    <div class="flex gap-2 p-3 md:p-0">
                        <div
                            v-for="(_image, i) in imgsprops"
                            :key="i"
                            class="h-2 w-2 rounded-full transition-all"
                            :class="i === slideSelect ? 'bg-primary-400 outline-1  outline-primary-400' : 'bg-white'"
                        />
                    </div>
                    <div
                        v-if="$viewport.isGreaterThan('sm')"
                        class="size-9 text-white hover:text-primary transition-colors flex items-center justify-center rounded-full cursor-pointer"
                        @click="nextSlide"
                    >
                        <UIcon name="si:chevron-right-alt-line" :size="20" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import type { EmblaCarouselType } from 'embla-carousel';
import emblaCarouselVue from 'embla-carousel-vue';
import fade from 'embla-carousel-fade';
import type { AirImgProps } from '~/types/image';
defineProps<{
    imgsprops: AirImgProps[];
}>();

const anim = ref(false);
const styleTimer = computed(() => ({
    'animation-duration': `${6500}ms`
}));

function startAnimation() {
    anim.value = false;
    setTimeout(() => {
        anim.value = true;
    }, 200);
}

const emit = defineEmits<{
    (e: 'indexChange', value: number): void;
}>();

const [emblaRef, emblaApi] = emblaCarouselVue({ loop: true, duration: 30 }, [fade({})]);
const slideSelect = ref(0);
let interval: ReturnType<typeof setInterval> | null = null;

function nextSlide() {
    emblaApi.value?.scrollNext();
}

function prevSlide() {
    emblaApi.value?.scrollPrev();
}

function changeIndex(emblaApi: EmblaCarouselType): void {
    if (interval) clearInterval(interval);
    startInterval();
    startAnimation();
    slideSelect.value = emblaApi.selectedScrollSnap();
    emit('indexChange', slideSelect.value);
}

function startInterval() {
    if (interval) clearInterval(interval);
    interval = setInterval(() => emblaApi.value?.scrollNext(), 6500);
}

onMounted(() => {
    if (!emblaApi.value) return;
    startInterval();
    startAnimation();
    emblaApi.value.on('select', changeIndex);
});
</script>
